"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionHelper = exports.SESSION_CUSTOM_EVENTS = void 0;
var CustomEvent_helper_1 = require("./CustomEvent.helper");
exports.SESSION_CUSTOM_EVENTS = {
    setDataInSession: "setDataInSession",
    getDataFromSession: "getDataFromSession",
    deleteDataInSession: "deleteDataInSession",
    deleteAllDataInSession: "deleteAllDataInSession",
};
exports.SessionHelper = {
    subscribeSetDataInSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.subscribe(exports.SESSION_CUSTOM_EVENTS.setDataInSession, listener);
    },
    subscribeGetDataFromSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.subscribe(exports.SESSION_CUSTOM_EVENTS.getDataFromSession, listener);
    },
    subscribeDeleteDataInSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.subscribe(exports.SESSION_CUSTOM_EVENTS.deleteDataInSession, listener);
    },
    subscribeDeleteAllDataInSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.subscribe(exports.SESSION_CUSTOM_EVENTS.deleteAllDataInSession, listener);
    },
    unsubscribeSetDataInSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.unsubscribe(exports.SESSION_CUSTOM_EVENTS.setDataInSession, listener);
    },
    unsubscribeGetDataFromSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.unsubscribe(exports.SESSION_CUSTOM_EVENTS.getDataFromSession, listener);
    },
    unsubscribeDeleteDataInSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.unsubscribe(exports.SESSION_CUSTOM_EVENTS.deleteDataInSession, listener);
    },
    unsubscribeDeleteAllDataInSession: function (listener) {
        CustomEvent_helper_1.CustomEventHelper.unsubscribe(exports.SESSION_CUSTOM_EVENTS.deleteAllDataInSession, listener);
    },
    setData: function (key, value) {
        return CustomEvent_helper_1.CustomEventHelper.publish(exports.SESSION_CUSTOM_EVENTS.setDataInSession, {
            key: key,
            value: value,
        });
    },
    getData: function (key) {
        return CustomEvent_helper_1.CustomEventHelper.publish(exports.SESSION_CUSTOM_EVENTS.getDataFromSession, {
            key: key,
        });
    },
    deleteData: function (key) {
        return CustomEvent_helper_1.CustomEventHelper.publish(exports.SESSION_CUSTOM_EVENTS.deleteDataInSession, {
            key: key,
        });
    },
    deleteAllData: function () {
        return CustomEvent_helper_1.CustomEventHelper.publish(exports.SESSION_CUSTOM_EVENTS.deleteAllDataInSession);
    },
    mock: function (store) {
        if (store === void 0) { store = {}; }
        var setDataListener = jest.fn(function (_a) {
            var detail = _a.detail;
            store[detail.key] = detail.value;
            detail.resolve(store);
        });
        this.subscribeSetDataInSession(setDataListener);
        var getDataListener = jest.fn(function (_a) {
            var detail = _a.detail;
            detail.resolve(store[detail.key]);
        });
        this.subscribeGetDataFromSession(getDataListener);
        var deleteDataListener = jest.fn(function (_a) {
            var detail = _a.detail;
            delete store[detail.key];
            detail.resolve(true);
        });
        this.subscribeDeleteDataInSession(deleteDataListener);
    },
};
